import React, { useEffect, useState } from "react";
// import big from "../assets/big.png";
import residentialImg from "../assets/residential.jpg";
import commercialIcon from "../assets/icon-commercial.svg";
import interiorIcon from "../assets/icon-interior.svg";
import renovationImg from "../assets/renovation.png";

const words = ["Precision", "Passion"];

const ScrollingWordsSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000); // 1.4s display + 0.6s scroll

    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <section className="bg-[#FFF6DA] font-poppins w-[full] h-[538px]">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10 px-6 py-16">
        {/* Text Section */}
        <div className="w-full md:w-6/12 text-center md:text-left">
          <h5 className="text-[#212129] text-sm font-medium uppercase mb-3 tracking-wide">
        Construction
      </h5>


          <h1 className="mb-6 text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Building the Future with
            <br />
            of{" "}
            <span className="inline-block h-[70px] overflow-hidden relative align-middle">
              <div
                className="transition-transform duration-[600ms] ease-in-out"
                style={{ transform: `translateY(-${index * 70}px)` }}
              >
                {words.map((word, i) => (
                  <div
                    key={i}
                    className="h-[70px] flex items-center text-[#07862B] text-[32px] sm:text-[42px] md:text-[48px] font-bold"
                  >
                    {word}
                  </div>
                ))}
              </div>
            </span>
          </h1>

          <h4 className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
           From residential to commercial, we deliver quality construction solutions that stand the test of time.
          </h4>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-6/12 flex justify-center">
          {/* <img
            src={big}
            alt="Global logistics illustration"
            className="w-[90%] max-w-[400px] sm:max-w-[500px] md:max-w-[560px]"
          /> */}
        </div>
      </div>
    </section>
      <section className="w-full bg-white py-20 px-4 sm:px-10 font-poppins">
      <div className="max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-14">
          <span className="inline-block text-xs px-4 py-1 bg-gray-200 text-gray-800 rounded-full font-medium mb-4">
            OUR SOLUTIONS
          </span>
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
            What We Do
          </h2>
          <p className="text-gray-500 text-sm sm:text-base max-w-2xl mx-auto">
            Delivering comprehensive construction solutions across residential,
            commercial, and industrial sectors.
          </p>
        </div>

        {/* GRID LAYOUT */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Residential Construction (2-column span) */}
          <div className="col-span-1 md:col-span-2 relative overflow-hidden rounded-2xl">
            <img
              src={residentialImg}
              alt="Residential Construction"
              className="w-full h-full object-cover rounded-2xl"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 rounded-2xl flex flex-col justify-end p-6">
              <h3 className="text-white text-lg sm:text-xl font-bold mb-1">
                Residential Construction
              </h3>
              <p className="text-white text-sm">
                From villas to apartments, we build homes that reflect your dreams.
              </p>
            </div>
          </div>

          {/* Commercial Projects */}
          <div className="bg-[#F7EBD9] rounded-2xl px-6 py-6 flex flex-col justify-start">
            <img
              src={commercialIcon}
              alt="Commercial Projects"
              className="w-[38px] h-[38px] mb-4"
            />
            <h3 className="text-gray-900 font-semibold mb-2 text-sm sm:text-base">
              Commercial Projects
            </h3>
            <p className="text-gray-600 text-sm">
              Offices, malls, and more — crafted with structural excellence.
            </p>
          </div>

          {/* Interior Fit-outs */}
          <div className="bg-[#DFF3E4] rounded-2xl px-6 py-6 flex flex-col justify-start">
            <img
              src={interiorIcon}
              alt="Interior Fit-outs"
              className="w-[38px] h-[38px] mb-4"
            />
            <h3 className="text-gray-900 font-semibold mb-2 text-sm sm:text-base">
              Interior Fit-outs
            </h3>
            <p className="text-gray-600 text-sm">
              Turn bare spaces into beautifully finished interiors with functional elegance.
            </p>
          </div>

          {/* Renovation & Remodeling (2-column span on small screen) */}
          <div className="col-span-1 md:col-span-2 relative overflow-hidden rounded-2xl">
            <img
              src={renovationImg}
              alt="Renovation & Remodeling"
              className="w-full h-full object-cover rounded-2xl"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 rounded-2xl flex flex-col justify-end p-6">
              <h3 className="text-white text-lg sm:text-xl font-bold mb-1">
                Renovation & Remodeling
              </h3>
              <p className="text-white text-sm">
                From villas to apartments, we build homes that reflect your dreams.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default ScrollingWordsSection;
